import {Backbone} from 'Vertebrae';
import {Degree} from '../model/degree';

export const Degrees = Backbone.Collection.extend({
    _name: 'Degree',
    model: Degree,
});
